import { SHOW_G5_DEVICES_MODAL, HIDE_G5_DEVICES_MODAL } from '../constants/ActionTypes';

const initialState = {
  open: false,
};

export default function g5DevicesModal(state = initialState, action) {
  switch (action.type) {
    case SHOW_G5_DEVICES_MODAL:
      return { ...state, open: true };
    case HIDE_G5_DEVICES_MODAL:
      return { ...state, open: false };
    default:
      return state;
  }
} 